import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { ScheduleState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: ScheduleState = getDefaultState();

const namespaced: boolean = true;

export const schedules: Module<ScheduleState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
